import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { StyledTextarea, Container } from './styles'
import { Instructions, Required } from '../../layout/mixins'

const Textarea = forwardRef(({
  name, value, onChange, placeholder, required, className, half, third, instructions
}, ref) => {
  const optionals = {}

  return (
    <Container third={third} half={half}>
      <StyledTextarea
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={className}
        ref={ref}
        defaultValue={value}
        title={placeholder}
      // eslint-disable-next-line react/jsx-props-no-spreading
        {...optionals}
      />

      {required ? (
        <Required>*</Required>
      ) : null}

      {instructions ? (
        <Instructions dangerouslySetInnerHTML={{ __html: instructions }} />
      ) : null}
    </Container>
  )
})

export default Textarea

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  half: PropTypes.bool,
  third: PropTypes.bool,
  instructions: PropTypes.string
}

Textarea.defaultProps = {
  value: '',
  onChange: () => {},
  placeholder: null,
  required: false,
  half: false,
  third: false,
  instructions: null
}
